import { render, staticRenderFns } from "./Message.vue?vue&type=template&id=2ea5f7d8&scoped=true&lang=pug&"
import script from "./Message.vue?vue&type=script&lang=ts&"
export * from "./Message.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea5f7d8",
  null
  
)

export default component.exports